var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import Collapse from '@material-ui/core/Collapse';
import useOnClickOutside from 'use-onclickoutside';
var StationSelect = function (_a) {
    var options = _a.options, defaultOption = _a.defaultOption, onSelect = _a.onSelect, defaultSelectedOptionId = _a.defaultSelectedOptionId;
    var _b = useState(null), selectedOption = _b[0], setSelectedOption = _b[1];
    var _c = useState(false), isOpen = _c[0], setIsOpen = _c[1];
    var ref = useRef(null);
    var onClickOption = function (area) {
        setSelectedOption(area);
        if (onSelect)
            onSelect(area);
    };
    useOnClickOutside(ref, function () { return setIsOpen(false); });
    useEffect(function () {
        if (!defaultSelectedOptionId)
            return;
        var option = options.find(function (item) { return item.id === defaultSelectedOptionId; });
        if (option)
            setSelectedOption(option);
    }, []);
    return (_jsxs("div", __assign({ className: 'select' + (isOpen ? ' select-expanded' : ''), onClick: function () { setIsOpen(function (prev) { return !prev; }); }, ref: ref }, { children: [_jsxs("div", __assign({ className: 'select-top' }, { children: [_jsx("div", { children: selectedOption && selectedOption.name || defaultOption }, void 0),
                    _jsx("img", { src: '/lulav-icons/expand-accordion-arrow.svg', alt: '', className: 'expand-accordion-icon' }, void 0)] }), void 0),
            _jsx(Collapse, __assign({ "in": isOpen, className: 'select-options' }, { children: __spreadArray([{ name: defaultOption }], options).map(function (item, index) {
                    return _jsx("div", __assign({ onClick: function () { return onClickOption(item); }, className: 'pointer select-option' + (selectedOption && selectedOption.id === item.id ? ' selected-option' : '') }, { children: item.name }), index);
                }) }), void 0)] }), void 0));
};
export default StationSelect;
//# sourceMappingURL=StationSelect.js.map